export const filtered = (items, typed, maxItems = 10) => {
    const scores = items.reduce((o, item) => {
        o[item[0]] = lcsScore(item[0], typed);
        return o;
    }, {});
    return items
        .slice()
        .sort((a, b) => scores[b[0]] - scores[a[0]])
        .slice(0, maxItems);
};
const lcsScore = (item, typed) => {
    if (item.length === 0 || typed.length === 0)
        return 0;
    if (item.includes(typed)) {
        return typed.length + 1 / item.length + (item.startsWith(typed) ? 1 : 0);
    }
    const lcs = item.length < typed.length
        ? lcsLength(typed, item)
        : lcsLength(item, typed);
    if (item[0].toLowerCase() === typed[0].toLowerCase()) {
        return lcs + 1 + (item[0] === typed[0] ? 1 : 0);
    }
    return lcs;
};
const lcsLength = (x, y) => {
    const m = x.length;
    const n = y.length;
    const L = [0];
    for (let i = 1; i <= n; ++i)
        L[i] = 0;
    for (let i = 1; i <= m; ++i) {
        for (let j = 1, prev = L[0]; j <= n; ++j) {
            const tmp = L[j];
            L[j] = x[i - 1] === y[j - 1] ? prev + 1 : Math.max(L[j - 1], L[j]);
            prev = tmp;
        }
    }
    return L[n];
};
//# sourceMappingURL=filter.js.map